import $ from 'jquery';
import { getCurrentBreakpoint } from '../utils/breakpoint';
import { Breakpoint } from '../types/breakpoint';
export default class ActiveOnClick {
    static init() {
        const $button = $('.js__active-on-click');
        if (!$button.length) {
            return;
        }
        $button.each((index, element) => {
            const $element = $(element);
            const $deactivateButton = $element.find('.js__deactivate-on-click');
            $element.on('click', () => {
                this.setElementActive($element, $deactivateButton);
            });
            $element.on('keydown', event => {
                if (event.key === 'Enter' || event.key === ' ') {
                    this.setElementActive($element, $deactivateButton);
                }
            });
            $deactivateButton.on('click', () => {
                setTimeout(() => {
                    this.setElementInactive($element, $deactivateButton);
                });
            });
        });
    }
    static setElementActive($element, $deactivateButton) {
        if (!this.isActiveAvailable($element)) {
            return;
        }
        $element.addClass('active');
        $deactivateButton.attr('tabindex', '0');
    }
    static setElementInactive($element, $deactivateButton) {
        $element.removeClass('active');
        $deactivateButton.attr('tabindex', '-1');
    }
    static isActiveAvailable($element) {
        const isActiveOnlyMobile = $element.data('active-on-click-only-mobile');
        if (!isActiveOnlyMobile) {
            return true;
        }
        const currentBreakpoint = getCurrentBreakpoint();
        return currentBreakpoint < Breakpoint.lg;
    }
}
